module.exports = __webpack_public_path__ + "media/images/help/OR_Icon_Black-b63bf776d3ca56f2c215953f38dd7dae.png";